// @flow

import React from "react";
import { localize } from "redux-i18n";
import { GSGrid, Chart, View } from "@components";
import type { AbsenceProfile } from "@modules/reporting/reducer/trends/absence-reason/types";

type OwnProps = $Exact<{
  absenceProfile: AbsenceProfile,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const TrendAbsenceReasonAbsenceProfile = ({ absenceProfile, t }: Props) => (
  <View gap={3}>
    <GSGrid
      columns={[
        {
          name: t("MEASURE"),
          key: "key",
          align: "left",
          width: "",
        },
        {
          name: t("VALUE"),
          key: "value",
          width: "",
        },
      ]}
      rows={[
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_TOTAL_DAYS_LOST"),
          value: absenceProfile ? absenceProfile.totalDaysLost : "",
        },
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_ABSENCE_SPELLS"),
          value: absenceProfile ? absenceProfile.totalAbsences : "",
        },
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_AVERAGE_DURATION"),
          value: absenceProfile ? absenceProfile.averageDuration : "",
        },
        {
          key: t("TRENDS_ABSENCE_REASON_MEASURE_DAYS_LOST_PER_EMPLOYEE"),
          value: absenceProfile ? absenceProfile.daysLostPerEmployee : "",
        },
      ]}
    />
    <Chart
      type="ColumnChart"
      title={t("TRENDS_ABSENCE_REASON_DLPE_BY_GENDER_TITLE")}
      className="mb-3"
      values={[
        ["Type", t("DAYS_LOST"), { role: "annotation" }],
        ...((absenceProfile || {}).daysLostPerEmployeeByGender || []).map(item => [
          t(item.description),
          item.value,
          item.value,
        ]),
      ]}
      options={{
        chartArea: {
          top: 50,
          width: "80%",
        },
        legend: {
          position: "none",
        },
      }}
      chartHeight={200}
    />
    <Chart
      type="ColumnChart"
      title={t("TRENDS_ABSENCE_REASON_DLPE_BY_AGE_GROUP_TITLE")}
      values={[
        ["Type", t("DAYS_LOST"), { role: "annotation" }],
        ...((absenceProfile || {}).daysLostPerEmployeeByAgeGroup || []).map(item => [
          t(item.description),
          item.value,
          item.value,
        ]),
      ]}
      options={{
        chartArea: {
          top: 50,
          width: "80%",
        },
        legend: {
          position: "none",
        },
      }}
      chartHeight={200}
    />
  </View>
);

export default localize()(TrendAbsenceReasonAbsenceProfile);
